let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iTUSr")).then(() => parcelRequire('jG2JK'));